import Global from '../global';

/*
* This function handles a 404 error as a success with empty response.
*
* @param  err       the error received from the request made
* @param  options   object containing the necessary options
*                   {
*                     dispatch,
*                     actionToDispatch,
*                     fromApiCall,
*                     fromFile
*                   }
*/
export function handle404Error(err, options) {
  const { dispatch, actionToDispatch, fromApiCall, fromFile } = options;
  // TODO add check here if the response.body has what it's expected
  // TODO in order to be sure that it's not handled a real 404 (endpoint not found like)
  if (err.response && err.response.status === 404) {
    Global.logger.info(`404 error on ${fromApiCall} in ${fromFile} with error message ${err.message}`);
    if (actionToDispatch) {
      dispatch(actionToDispatch([]));
    }
  } else {
    Global.logger.error(`error on ${fromApiCall} in ${fromFile} with error message ${err.message}`);
    return [];
  }
}

